var _rect, _rect2, _rect3, _path, _circle, _circle2, _circle3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _circle4, _mask, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInfoIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 191,
    height: 158,
    fill: "none",
    viewBox: "0 0 191 158",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 43.495,
    height: 16.257,
    x: 32.514,
    y: 142.981,
    fill: "#DCF3FF",
    rx: 8.128,
    transform: "rotate(-30 32.514 142.981)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 21.651,
    height: 16.239,
    x: 10.619,
    y: 99.286,
    fill: "#DCF3FF",
    rx: 8.119,
    transform: "rotate(-30 10.62 99.286)"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 16.257,
    height: 16.257,
    x: 136.031,
    y: 8.128,
    fill: "#DCF3FF",
    rx: 8.128,
    transform: "rotate(-30 136.031 8.128)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#DCF3FF",
    fillRule: "evenodd",
    d: "M41.351 62.793A8.128 8.128 0 0049.43 76.9l25.037-14.455a8.128 8.128 0 018.129 14.078l-20.28 11.709.048-.028L128 50.308l.059-.034-1.272.734a8.128 8.128 0 01-11.103-2.975 8.128 8.128 0 012.975-11.104l6.029-3.48a8.129 8.129 0 00-8.19-14.043L41.351 62.793zm47.32 47.765a8.129 8.129 0 008.146 14.069l60.324-34.828a8.13 8.13 0 00-8.129-14.079l-20.029 11.564a7.96 7.96 0 00.307-.187 8.129 8.129 0 01-8.123-14.062c-.096.05-.191.102-.286.155l.546-.315.063-.037 27.785-16.041.063-.036 6.837-3.948a8.128 8.128 0 002.975-11.103 8.128 8.128 0 00-11.103-2.975L47.911 96.548a8.129 8.129 0 008.084 14.104l25.404-14.667a8.128 8.128 0 118.129 14.079l-.856.494z",
    clipRule: "evenodd"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 182.232,
    cy: 95.808,
    r: 3.982,
    stroke: "#DCF3FF",
    strokeWidth: 2.5
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 31.033,
    cy: 41.859,
    r: 2.9,
    stroke: "#DCF3FF",
    strokeWidth: 2.5
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 89.673,
    cy: 144.704,
    r: 2.9,
    stroke: "#DCF3FF",
    strokeWidth: 2.5
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    width: 10.104,
    height: 1.804,
    x: 115.654,
    y: 4.15,
    fill: "#DCF3FF",
    rx: 0.902
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    width: 10.104,
    height: 1.804,
    x: 121.609,
    fill: "#DCF3FF",
    rx: 0.902,
    transform: "rotate(90 121.609 0)"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    width: 7.578,
    height: 1.804,
    x: 150.658,
    y: 120.256,
    fill: "#DCF3FF",
    rx: 0.902
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    width: 7.578,
    height: 1.804,
    x: 155.35,
    y: 117.459,
    fill: "#DCF3FF",
    rx: 0.902,
    transform: "rotate(90 155.35 117.459)"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    width: 7.578,
    height: 1.804,
    x: 6.857,
    y: 83.629,
    fill: "#DCF3FF",
    rx: 0.902
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    width: 7.578,
    height: 1.804,
    x: 11.549,
    y: 80.832,
    fill: "#DCF3FF",
    rx: 0.902,
    transform: "rotate(90 11.549 80.832)"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 95.5,
    cy: 78.5,
    r: 38.75,
    fill: "#fff",
    stroke: "#32A3F5",
    strokeWidth: 2.5
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "mask0",
    width: 75,
    height: 75,
    x: 58,
    y: 41,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 95.5,
    cy: 78.5,
    r: 37.5,
    fill: "#fff"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#C0E4FF",
    d: "M95.5 37.75H137V118.25H95.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#32A3F5",
    d: "M92.573 71.503h6.055V96.75h-6.055V71.503zm3.052-4.161c-1.098 0-2.018-.331-2.76-.993-.744-.693-1.115-1.544-1.115-2.553s.371-1.844 1.114-2.506c.743-.693 1.663-1.04 2.761-1.04s2.018.331 2.76.993c.744.63 1.115 1.434 1.115 2.411 0 1.04-.371 1.923-1.114 2.648-.71.693-1.63 1.04-2.761 1.04z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoIcon);
export default __webpack_public_path__ + "static/media/info-icon.7025757e.svg";
export { ForwardRef as ReactComponent };